import React, { useEffect, useState } from 'react'
import { jsonrpc } from '~/shared/api/jsonrpc'

type Balance = {
    amount: number
    symbol: string
}

/** One currency on the br1 house account, split by whose money it is.
 *  See br1/bank/views/house_position.py. */
export type HouseCurrency = {
    symbol: string
    balance: number
    custody_frozen: number
    custody_held: number
    custody: number
    house: number
}

/** Store and pack sales, net of refunds, public players only (D-101/D-113).
 *  Never booked to br1, so never part of the house share. */
export type HouseSales = {
    symbol: string
    store: number
    packs: number
    total: number
}

export type HousePosition = {
    as_of: string | null
    currencies: HouseCurrency[]
    sales?: HouseSales[]
}

const initialHouse: HousePosition = { as_of: null, currencies: [], sales: [] }

interface IBankContext {
    house: HousePosition
    usersBalance: Balance[]
    /** When the "Users" figures were read, by this browser. */
    usersAsOf: string | null
    reloadBalance: () => void
}

export const BankContext = React.createContext<IBankContext>({
    house: initialHouse,
    usersBalance: [],
    usersAsOf: null,
    reloadBalance: () => {},
})

export const BankProvider = ({ children }) => {
    const [house, setHouse] = useState<HousePosition>(initialHouse)
    const [usersBalance, setUsersBalance] = useState<Balance[]>([])
    const [usersAsOf, setUsersAsOf] = useState<string | null>(null)

    const reloadBalance = () => {
        jsonrpc('bank.house_position', {}).then((resp) => setHouse(resp?.result || initialHouse))
        jsonrpc('bank.users_balance', {}).then((resp) => {
            setUsersBalance(resp?.result || [])
            setUsersAsOf(new Date().toISOString())
        })
    }

    useEffect(() => {
        reloadBalance()
    }, [])

    return (
        <BankContext.Provider value={{ house, usersBalance, usersAsOf, reloadBalance }}>
            {children}
        </BankContext.Provider>
    )
}
